import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Sport} from '@/types/common';
import {createSelector} from 'reselect';
interface SportsState {
  sports: Record<string, Sport>;
}

const initialState: SportsState = {sports: {}};

const sportsSlice = createSlice({
  name: 'sports',
  initialState,
  reducers: {
    setSports: (state, action: PayloadAction<Record<string, Sport>>) => {
      state.sports = action.payload;
    }
  }
});

export const selectSports = (state: {sports: SportsState}) =>
  state.sports.sports;

export const selectSportsValues = createSelector([selectSports], (sports) =>
  Object.values(sports)
);

export const {setSports} = sportsSlice.actions;

export default sportsSlice.reducer;
